import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { Donor } from '@interfaces';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService): GridSetup<Donor> {

	return {
		rowName: { singular: 'Donor', plural: 'Donors' },
		getRowKey: row => '' + row.donorId,
		stateKey: 'devo-donors-staff-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util),
		// renderRowClasses: row => row.status == 'Active' ? [] : ['grid-cell-strikethrough', 'grid-cell-gray-text'],
	}
}
